import styles from './index.module.scss'
import { Popover, Input, Button } from 'antd';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Iconfont from '@utils/Iconfont';
import API, { commonApiInvoker } from '@api/api.js';

const { TextArea } = Input;

const discontentList = ['人体残缺', '面部扭曲', '模特不够好看', '模特不符合需求', '背景不符合需求', '背景不够美观']

export default function FeedbackText(props) {
    const { item } = props
    const [discontentSelect, setDiscontentSelect] = useState([])
    const [comments, setComments] = useState()
    const [open, setOpen] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);

    const selectClick = (item) => {
        if (discontentSelect.includes(item)) {
            setDiscontentSelect((prev) => prev.filter((selectedItem) => selectedItem !== item));
        } else setDiscontentSelect((prev) => [...prev, item]);
    }
    const disabledDislike = useMemo(() => {
        return discontentSelect.length == 0 && !comments
    }, [discontentSelect, comments])

    const onCancleClick = () => {
        setOpen(false)
        setDiscontentSelect([])
        setComments()
    }

    const scoreClick = (score) => {
        if (item?.results?.[0]?.score !== '') return
        API.batchScoreImage({
            taskId: item?.taskId.split('_')[0],
            imageId: item?.results?.[0]?.id,
            score: score,
            reason: discontentSelect || '',
            comments: comments || '',
        }).then((res) => {
            if (res?.code === 0) {
                setOpen(false)
                setDiscontentSelect([])
                setComments()
                setShowFeedback(true);
                setTimeout(() => {
                    setShowFeedback(false);
                }, 3000);
                props.fetchProjectDetail()
            }
        })
    }

    const feedbackBox = (
        <div className={styles.discontent_count}>
            <p className={styles.discontent_count_p}>
                {
                    discontentList.map((item, index) => {
                        const isSelected = discontentSelect.includes(item);
                        return <span
                            key={index}
                            onClick={() => selectClick(item)}
                            className={`${styles.discontent_count_select} ${isSelected && styles.discontent_count_selected}`}>
                            {item}
                        </span>
                    })
                }
            </p>
            <p style={{ margin: '10px 0', fontSize: '16px' }}>其他问题</p>
            <TextArea
                style={{ marginBottom: '20px' }}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                rows={4}
                placeholder="任何让您不满意的原因都请写在这边1"
                maxLength={300}
                showCount />
            <div>
                <Button className={styles.feedbackBtn} style={{ marginRight: '12px' }} onClick={() => onCancleClick()}>取消</Button>
                <Button className={styles.feedbackBtn} type='primary' disabled={disabledDislike} onClick={() => scoreClick(2)} >提交</Button>
            </div>
        </div>
    )

    return (
        <div className={styles.feedbackText}>
            <p className={`${styles.feedbackResText} ${showFeedback ? styles.show : ''}`}>
                <img src={"https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/feedbackSuccessed.png"} alt="" />
                感谢您的反馈，祝您生活愉快
            </p>
            <p>效果反馈：</p>
            <p>
                {
                    item?.results?.[0]?.score === 0 ?
                        <Iconfont className={styles.icon} style={{ color: '#006EFF' }} type="icon-likeFilled" /> :
                        <Iconfont className={styles.icon} type="icon-likeOutlined" onClick={() => scoreClick(0)} />
                }
                <Popover
                    content={feedbackBox}
                    open={open}
                    placement="rightTop"
                    trigger="click">
                    {
                        item?.results?.[0]?.score === 1 || item?.results?.[0]?.score === 2 ?
                            <Iconfont className={styles.icon} style={{ color: '#006EFF' }} type="icon-dislikeFilled" /> :
                            <Iconfont className={styles.icon} type="icon-dislikeOutlined"
                                onClick={() => {
                                    if (item?.results?.[0]?.score !== '') return;
                                    setOpen(true)
                                }} />
                    }
                </Popover>

            </p>
        </div>
    )
}